export default "__VITE_ASSET__WamECpRN__"